/**
 * Semantic push event types for driver-assigned task notifications.
 * `TASK_UPDATED` is the only silent (data-only) type — all others are visible.
 */
export const PUSH_EVENT_TYPE = {
  TASK_ASSIGNED: 'task-assigned',
  TASK_CANCELLED: 'task-cancelled',
  TASK_UNASSIGNED: 'task-unassigned',
  TASK_UPDATED: 'task-updated',
} as const;
export type PushEventType = (typeof PUSH_EVENT_TYPE)[keyof typeof PUSH_EVENT_TYPE];

/** Event types that must surface a visible system/local notification on-device. */
export const VISIBLE_PUSH_EVENT_TYPES: PushEventType[] = [
  PUSH_EVENT_TYPE.TASK_ASSIGNED,
  PUSH_EVENT_TYPE.TASK_UNASSIGNED,
  PUSH_EVENT_TYPE.TASK_CANCELLED,
];

/** Expo push `data` payload for task push events — Expo requires a JSON-serializable, flat string-to-string map. */
export interface PushTaskDataPayload {
  taskId: string;
  type: PushEventType;
}
